import React from 'react';
import { FlexColumn, FlexRow, Textarea, Typography } from 'design-system';
import LeadershipMessageContent from '../../components/LeadershipMessageContent';

export default function DirectorMessage({ leadershipUser, recipient }) {
  return (
    <FlexColumn align="stretch" className="py-3">
      <Typography variant="h2" fontWeight="bold" className="text-center">
        Message from Leadership
      </Typography>

      <Typography variant="h4" fontWeight="bold" className="mt-4">
        Hi, {recipient}
      </Typography>

      <LeadershipMessageContent
        leadershipUser={leadershipUser}
        component="div"
        variant="body1"
        className="mt-2"
        style={{ lineHeight: 2 }}
      />

      <FlexRow align="center" fullWidth className="mt-5 pb-2">
        <FlexRow
          align="center"
          justify="center"
          fullWidth={false}
          style={{ borderRadius: '50%', overflow: 'hidden', width: 60, height: 60, flexShrink: 0 }}
        >
          <img
            width="60px"
            height="60px"
            src={leadershipUser?.image}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
            alt="user"
            style={{ objectFit: 'contain' }}
          />
        </FlexRow>

        <FlexColumn align="start" fullWidth={false} className="ml-4">
          <Typography variant="body1" fontWeight="bold">
            {leadershipUser?.name}
          </Typography>
          <Typography variant="body2">{leadershipUser?.companyName}</Typography>
          <Typography variant="body2" className="small">
            {leadershipUser?.email}
          </Typography>
        </FlexColumn>
      </FlexRow>

      <Textarea
        rows={4}
        className="mt-4 rounded-sm text-input"
        placeholder="Your message here"
        readOnly
        style={{ resize: 'none' }}
      />
    </FlexColumn>
  );
}
